<template>
  <q-input
    ref="inputRef"
    v-bind="$attrs"
    :model-value="modelValue"
    type="number"
    inputmode="numeric"
    @update:modelValue="onInput"
    @keypress="onKeyPress"
  >
    <template
      v-if="$slots.prepend"
      #prepend
    >
      <slot name="prepend" />
    </template>
  </q-input>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  max: {
    type: Number,
    default: 999,
  },
  modelValue: {
    type: [Number, String],
    default: null,
  },
});

const emit = defineEmits(['update:modelValue']);

const inputRef = ref(null);

const previous = ref(props.modelValue);

function onInput(value) {
  value = value <= props.max ? value.replace(/[^0-9]+/g, '') : previous.value;

  emit('update:modelValue', value && +value);

  previous.value = value;
}

function onInputNative({ target }) {
  target.value = target.value <= props.max ? target.value.replace(/[^0-9]+/g, '') : previous.value;
}

function onKeyPress(e) {
  if (Number.isNaN(+e.key)) {
    e.preventDefault();
  }
}

onMounted(() => {
  inputRef.value.$el.addEventListener('input', onInputNative);
});

onBeforeUnmount(() => {
  inputRef.value.$el.removeEventListener('input', onInputNative);
});
</script>

<style lang="scss" scoped>
.q-field--error :deep(input) {
  border: 2px solid $negative !important;
}
</style>
